/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { usePrevious, useRendersCount } from 'react-use';
import { makeStyles } from 'tss-react/mui';

import { localPreferences } from 'app-components/utils/core';

import Badge from '@mui/material/Badge';

const useStyles = makeStyles()((_theme, children) => ({
  badge: {
    opacity: 0.2,
    marginLeft: 22,
  },
  root: {
    width: '-webkit-fill-available',
    ...(!children && { position: 'absolute' }),
  },
}));

const rendersTotals = {};

const RendersCount = (props) => {
//////////////////////////////////////////////
  const { children, id, dataTestid, anchorOrigin, classes: restClasses, ...rest } = props;
  const { classes } = useStyles(children);
  const rendersCount = useRendersCount();
  const rendersCountPrev = usePrevious(rendersCount);
  const rendersTotal = useMemo(() => {
    if (id) {
      const rendersDelta = rendersCount - (rendersCountPrev ?? 0);
      rendersTotals[id] = (rendersTotals[id] ?? 0) + rendersDelta;
    }
    return rendersTotals[id];
  }, [rendersCount, rendersCountPrev, id]);

  if (localPreferences.getItem('render-count') ?? true) {
    return (
      <Badge
        id={id}
        data-testid={dataTestid ?? id}
        badgeContent={rendersTotal ? `${rendersCount} (${rendersTotal})` : rendersCount}
        color='primary'
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
          ...anchorOrigin,
        }}
        classes={{ badge: classes.badge, root: classes.root, ...restClasses }}
        {...rest}
      >
        {children}
      </Badge>
    );
  }
///////////
  return props.children; // eslint-disable-line no-unreachable
};

RendersCount.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  slotProps: PropTypes.any,
};

// eslint-disable-next-line react/display-name
export const withRendersCount = (WrappedComponent) => (props) => (
  <RendersCount>
    <WrappedComponent {...props} />
  </RendersCount>
);

export default RendersCount;
